import criticalError from './critical-error';

export default {
  criticalError,
};
